/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { ICustomer } from "../../models/Customers/customer";
import { GET_ALL_CUSTOMERS, REMOVE_CUSTOMER, SET_NO_CUSTOMER, SET_SELECTED_CUSTOMER } from "./types";

export const getAllCustomersAction = (customers: ICustomer[], selectedCustomer: ICustomer | {}, noCustomer: boolean, pagination) => {
  return {
    type: GET_ALL_CUSTOMERS,
    customers: customers,
    selectedCustomer,
    noCustomer,
    pagination
  };
};

export const setSelectedCustomerAction = (selectedCustomer: ICustomer) => {
  return {
    type: SET_SELECTED_CUSTOMER,
    selectedCustomer,
  };
};

export const setNoCustomerAction = (noCustomer: boolean) => {
  return {
    type: SET_NO_CUSTOMER,
    noCustomer,
  };
};

export const removeCustomerAction = (id: string) => {
  return {
    type: REMOVE_CUSTOMER,
    id,
  }
};